export default __webpack_public_path__ + "static/Bitrate_Test_12_h264_hp_1920000-bcb53ca54bb76fea190a144d41fd286f.avif";